import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
import { numConvert, calculation } from '@/method';

const totalIndex = [3, 6, 10, 14, 15, 18, 22, 23, 27, 33, 34, 37];
const percentIndex = [37];
export const nameList = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec", 'full'];

export const compute = (data) => {
    const sumIndex = {
        3: [0, 1, 2],
        6: [4, 5],
        10: [7, 8, 9],
        14: [12, 13],
        15: [3, 6, 10, 11, 14],
        18: [16, 17],
        22: [19, 20, 21],
        23: [18, 22],
        27: [24, 25, 26],
        33: [28, 29, 30, 31, 32],
        34: [15, 23, 27, 28]
    };

    (['janf', ...nameList]).forEach(name => {
        if (name != 'full') {
            const rn = `${name}_rn`;
            const rev = `${name}_rev`;
            Object.entries(sumIndex).forEach(index => {
                data[index[0]][rn] = index[1].reduce((a, b) => a += numConvert(data[b][rn]), 0).toFixed(2);
                data[index[0]][rev] = [...index[1], ...(index[0] == 34 ? [31, 32] : [])].reduce((a, b) => a += numConvert(data[b][rev]), 0).toFixed(2);
            });
        }
    });
    data.forEach((item, index) => {
        data[index]['full_rn'] = nameList.reduce((a, b) => {
            if (b == 'full') return a;
            return (a + numConvert(item[`${b}_rn`]))
        }, 0).toFixed(2);
        data[index]['full_rev'] = nameList.reduce((a, b) => {
            if (b == 'full') return a;
            return (a + numConvert(item[`${b}_rev`]))
        }, 0).toFixed(2);
    });

    data.forEach((item, index) => {
        if (index != 37) (['janf', ...nameList]).forEach(name => {
            data[index][`${name}_adr`] = calculation(data[index][`${name}_rev`], data[index][`${name}_rn`]);
        });
    });

    (['janf', ...nameList]).forEach(name => {
        data[36][`${name}_rn`] = ~~(data[35][`${name}_rn`] - data[34][`${name}_rn`]);
        data[37][`${name}_rn`] = calculation(data[34][`${name}_rn`], data[35][`${name}_rn`], 4);
        data[37][`${name}_adr`] = calculation(data[34][`${name}_rev`], data[34][`${name}_rn`], 2);
        data[37][`${name}_rev`] = (data[37][`${name}_rn`] * data[37][`${name}_adr`]).toFixed(2);
    });

    return data;
}

export const columns = (onChange, date, type, print, data1_1) => {
    // type 1 forecast 2 actual
    const month = moment(date).format('M');
    const year = moment(date).format('YYYY');
    const sqlName = type == 1 ? "_4new_4_3_1_forecast" : type == 2 ? "_4new_4_3_1_actual" : '_4new_4_3_1_budget';
    // 对比1.1 平均房价
    const _data1_1 = _.get(data1_1, `3.${type == 1 ? 'prediction' : type == 2 ? 'actual' : 'budget'}`, 0);
    let key = [];
    if (process.env.NODE_ENV === "development") key = [{
        title: "Index",
        dataIndex: 'index',
        key: 'index',
        align: "center",
        fixed: print ? false : "left",
        width: 50,
        render: (text, record, index) => {
            const props = {
                text: `${index}`,
                index,
                type: 'text',
                name: "index",
                onChange,
                totalIndex,
            };
            return <TableText data={props} />
        }
    }];
    return [
        ...key,
        {
            title: year,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: print ? false : "left",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                    compared: {
                        title: ['name'],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        },
        ...nameList.map((name, i) => {
            const title = type == 3 ? 'Budget' : name == 'full' ? 'Actual/Forecast' : i < month ? 'Actual' : 'Forecast';
            const childTitle = name == 'full' ? "FULL YEAR" : `${~~(i + 1)}月`;
            return {
                title: `${year} ${title}`,
                align: "center",
                width: 450,
                children: [{
                    title: childTitle,
                    align: "center",
                    width: 450,
                    children: [{
                        title: "RNs",
                        dataIndex: `${name}_rn`,
                        key: `${name}_rn`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = [title, childTitle, 'RNs'];
                            const props = {
                                text,
                                index,
                                type: [31, 32].includes(index) ? '' : percentIndex.includes(index) ? 'percent' : (name == 'full' || print || i < ~~(month - 1)) ? 'number' : [...totalIndex, 36].includes(index) ? 'number' : "inputNumber",
                                name: `${name}_rn`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }, {
                        title: "ADR",
                        dataIndex: `${name}_adr`,
                        key: `${name}_adr`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = [title, childTitle, 'ADR'];
                            const props = {
                                text,
                                index,
                                type: [29, 30, 31, 32, 35, 36].includes(index) ? '' : "number",
                                name: `${name}_adr`,
                                onChange,
                                totalIndex,
                                yellowText: index == 34 && i == ~~(month - 1) && _data1_1 != text ? '与1.1对比不一致，请检查' : ''
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }, {
                        title: "REVENUE",
                        dataIndex: `${name}_rev`,
                        key: `${name}_rev`,
                        width: 150,
                        align: "center",
                        render: (text, record, index) => {
                            const title = [title, childTitle, 'REVENUE'];
                            const props = {
                                text,
                                index,
                                type: [29, 30, 35, 36].includes(index) ? '' : (name == 'full' || print || i < ~~(month - 1)) ? 'number' : [...totalIndex, 36].includes(index) ? 'number' : "inputNumber",
                                name: `${name}_rev`,
                                onChange,
                                totalIndex,
                            };
                            props.compared = {
                                title,
                                record,
                                sqlName
                            };
                            return <TableText data={props} />
                        }
                    }]
                }],

            }
        })
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.1/compute.js